export default __webpack_public_path__ + "165dd80b4139ceffe54611f71e3f1230.png";